module.exports = __webpack_public_path__ + "img/knue_gallery11.6a188344.jpg";